import { Map } from 'ol';
import MapEvent from 'ol/MapEvent';
import { type Types as MapEventTypes } from 'ol/MapEventType';
import { useEffect } from 'react';
import { useOpenLayersContext } from './OpenLayersContext';

export function useMap() {
  return useOpenLayersContext().map;
}

export function useMapEvent<T extends MapEventTypes>(
  type: T,
  handler: (event: MapEvent) => void,
): Map {
  const map = useMap();

  useEffect(
    function addMapEventHandler() {
      map.on(type, handler);

      return function removeMapEventHandler() {
        map.un(type, handler);
      };
    },
    [map, type, handler],
  );

  return map;
}
